import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolFileType from '../../types/file-type'
import CreationToolOutputType from '../../types/output-type'
import CreationToolSourceEditor from '../../types/source-editor'
import { StickerBlock } from '../blocks'
import VideoPlayer from '../video-player'
import Artboard from './artboard'
import { CreationSourceEditorContext } from './manager'

const MAX_HEIGHT = 500

const Container = styled(StickerBlock)`
    margin: 0 auto;
    position: relative;
`

type Props = {
    width: number
}

const CreationSourceEditorPreview = ({ width }: Props) => {
    const { currentEditor, source, edits, outputType, setPreviewPlayheadTime } = useContext(CreationSourceEditorContext)
    const isVideo = source.type === CreationToolFileType.VIDEO || source.type === CreationToolFileType.VIDEO_EMBED
    const isPlayheadRequired = CreationToolSourceEditor.requiresPreviewPlayheadTime(currentEditor)
    const aspectRatio = source.width / source.height
    const playerHeight = Math.min(width / aspectRatio, MAX_HEIGHT)
    const playerWidth = playerHeight * aspectRatio

    return (
        <Container style={{ width: playerWidth }}>
            {isVideo && !source.frames.length && (
                <VideoPlayer
                    {...{
                        source,
                        startTime: edits?.trim?.start || 0,
                        endTime: edits?.trim?.end || source.duration,
                        width: playerWidth,
                        hideButtons: outputType !== CreationToolOutputType.Video,
                        onTimeUpdate: isPlayheadRequired ? setPreviewPlayheadTime : undefined,
                    }}
                >
                    <Artboard width={playerWidth} height={playerHeight} />
                </VideoPlayer>
            )}
        </Container>
    )
}

export default CreationSourceEditorPreview
